/* eslint-disable @typescript-eslint/no-deprecated -- DEPRECATION: [APPDEV-17834] BREAKING-CHANGE: migrate to ChartTooltip before next major. */
import {
  type PropsWithChildren,
  type MouseEvent as ReactMouseEvent,
} from 'react';

import { InteractiveChartTooltip } from '../../../../core/components/tooltip/InteractiveChartTooltip/components/InteractiveChartTooltip.js';
import { useSeriesBasedItemEstimatedSize } from '../../../../core/components/tooltip/InteractiveChartTooltip/hooks/useSeriesBasedItemEstimatedSize.js';
import { useScrollResponsiveChartBounds } from '../../../../core/hooks/useScrollResponsiveChartBounds.js';
import { TooltipItem } from '../../../../core/types/tooltip.js';
import { calculateAdjustedTooltipPosition } from '../../../../core/utils/calculate-adjusted-tooltip-position.js';
import { useExploreState } from '../../../hooks/store/selectors.js';
import { useHistogramChartOverlayRef } from '../../../hooks/useHistogramChartOverlayRef.js';
import { ADJUSTED_LAYOUT_OFFSET } from '../constants.js';

interface HistogramTooltipWrapperProps {
  tooltipItems: TooltipItem[];
  onMouseLeave: (event?: ReactMouseEvent) => void;
  onScrollContent: (event?: Event) => void;
}

export const HistogramTooltipWrapper = ({
  tooltipItems,
  onMouseLeave,
  onScrollContent,
  children,
}: PropsWithChildren<HistogramTooltipWrapperProps>) => {
  const { pinned, position } = useExploreState();
  const chartRef = useHistogramChartOverlayRef();
  const bounds = useScrollResponsiveChartBounds(chartRef, pinned)();

  const estimatedItemSize = useSeriesBasedItemEstimatedSize(
    tooltipItems,
    'single-line',
  );

  const adjustedTooltipPosition = calculateAdjustedTooltipPosition(
    bounds,
    position,
    ADJUSTED_LAYOUT_OFFSET,
  );

  const showTooltip = tooltipItems.length && adjustedTooltipPosition;

  return showTooltip ? (
    <InteractiveChartTooltip
      position={adjustedTooltipPosition}
      pinned={pinned}
      itemSize={estimatedItemSize}
      updatePositionWhenPinned={true}
      onMouseLeave={onMouseLeave}
      onScrollContent={onScrollContent}
    >
      {children}
    </InteractiveChartTooltip>
  ) : null;
};
